export const arrDeleteAt = <Value = any>(
  arr: Value[],
  index: number | { (value: Value): boolean },
) => {
  const index_ = typeof index === "function" ? arr.findIndex(index) : index;

  return [...arr.slice(0, index_), ...arr.slice(index_ + 1)];
};

export const arrInsertAt = <Value = any>(
  arr: Value[],
  index: number | { (value: Value): boolean },
  value: Value,
) => {
  const index_ = typeof index === "function" ? arr.findIndex(index) : index;

  return [...arr.slice(0, index_), value, ...arr.slice(index_)];
};

export const arrReplaceAt = <Value = any>(
  array: Value[],
  index: number | { (value: Value): boolean },
  value: Value,
  insertIfNotFound: boolean = false,
) => {
  const ret = array.slice(0);
  const index_ = typeof index === "function" ? array.findIndex(index) : index;
  if (index_ === -1 && insertIfNotFound) {
    ret[ret.length] = value;
  } else {
    ret[index_] = value;
  }
  return ret;
};

export const arrReplaceMany = <Value = any>(
  arr: Value[],
  indexes: number[] | { (value: Value, repValue: Value): boolean },
  values: Value[],
  insertIfNotFound: boolean = false,
) => {
  let ret = arr.slice(0);
  values.forEach((repValue, index) => {
    ret = arrReplaceAt(
      ret,
      Array.isArray(indexes)
        ? indexes[index]
        : (value) => {
            return indexes(value, repValue);
          },
      repValue,
      insertIfNotFound,
    );
  });
  return ret;
};

export const arrReplaceAtOrInsertInTheEnd = <Value = any>(
  array: Value[],
  index: number | { (value: Value): boolean },
  value: Value,
) => {
  return arrReplaceAt(array, index, value, true);
};
